/* 🤖 this file was generated by svg-to-ts */
export const rpgAwesomeIconCastleEmblem: {
  name: 'castle_emblem';
  data: string;
} = {
  name: 'castle_emblem',
  data: `<svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" x="0" y="0" version="1.1" viewBox="0 0 613 613"><path d="M303.895 29.493c-152.385 0-275.919 123.532-275.919 275.919 0 82.532 36.247 156.588 93.677 207.151V346.095L104.9 318.868h9.074l53.054-136.824 52.357 136.824h9.773l-17.451 27.227v21.642h44.677V220.44l-16.754-27.227h9.074L301.758 56.39l-.002-.005.002.003-.001.002 53.053 136.82h9.074l-17.451 27.227v105.412h43.98V285.36l-17.451-27.227h9.773l52.358-136.824 53.054 136.824h9.074l-16.754 27.227v232.064c60.705-50.613 99.344-126.796 99.344-212.013.002-152.386-123.53-275.918-275.916-275.918z"/></svg>`,
};
